/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Eficacia desglosada por tipo de lanzamiento.
 */
export interface ThrowTypeEfficiencyDTO { 
    throw_type: string;
    total: number;
    goals: number;
    percentage: number;
}

